import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetTGBetChannelLink } from "./service";

export const useGetTGBetChannelLink = ({ options }) => {
  return useQuery(
    [queryKey.TG_BET_CHANNEL_LINK],
    () =>
      apiGetTGBetChannelLink({}).then((res) => {
        return res.data;
      }),
    {
      staleTime: 10 * (60 * 1000), //10mins
      cacheTime: 10 * (60 * 1000), //10mins
      ...options,
    },
  );
};
